import { Injectable } from '@angular/core'

import { Observable, catchError, map, of } from 'rxjs'

import {
  BlueBeanOperatorMappingsGQL,
  ImportBlueBeanOperatorMappingGQL,
  ImportBlueBeanOperatorMappingMutation,
  BlueBeanOperatorMappingsQuery,
} from '../../../../_generated/graphql'
import { throwIfCustomError } from '../../../util/throwIfCustomError'
import { assertGraphqlData } from '../../../util/assertGraphqlData'

export type BlueBeanOperatorMappingView =
  BlueBeanOperatorMappingsQuery['blueBeanOperatorMappings'][number]

export type ImportBlueBeanOperatorMappingResultView =
  ImportBlueBeanOperatorMappingMutation['importBlueBeanOperatorMapping']

@Injectable({
  providedIn: 'root',
})
export class BlueBeanOperatorMappingService {
  constructor(
    private blueBeanOperatorMappingsGQL: BlueBeanOperatorMappingsGQL,
    private importBlueBeanOperatorMappingGQL: ImportBlueBeanOperatorMappingGQL,
  ) {}

  getBlueBeanOperatorMappings(): Observable<BlueBeanOperatorMappingView[]> {
    return this.blueBeanOperatorMappingsGQL
      .fetch({ fetchPolicy: 'no-cache' })
      .pipe(
        map((res) => {
          assertGraphqlData(res)
          return res.data.blueBeanOperatorMappings
        }),
      )
  }

  importBlueBeanOperatorMapping(
    csvBase64: string,
  ): Observable<ImportBlueBeanOperatorMappingResultView | undefined> {
    return this.importBlueBeanOperatorMappingGQL
      .mutate({ variables: { csvBase64 }, fetchPolicy: 'no-cache' })
      .pipe(
        map((res) => res.data?.importBlueBeanOperatorMapping),
        catchError((error: unknown) => {
          throwIfCustomError(error)
          return of(undefined)
        }),
      )
  }
}
